import React from "react"

const HSeparator = () => {
    return (
        <div className="m-4 border border-secondary border-opacity-30 border-b-2"></div>
    )
}

export default HSeparator
